import {GenericButton} from '../../Buttons/GenericButton'

import type {XcNwBlock_ButtonTypeBlockRowType_Fragment} from '@sdox/api'

export type ButtonTypeBlockRowTypeProps = XcNwBlock_ButtonTypeBlockRowType_Fragment

export const BlockButtonRow = (props: ButtonTypeBlockRowTypeProps) => {
  const {items} = props

  return (
    <div className={'flex flex-wrap gap-spacing-12'}>
      {items.map((item, index) => (
        <GenericButton
          key={index}
          {...item}
        />
      ))}
    </div>
  )
}
